import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ListComponent} from './modules/partners/list/list.component';
import {AddComponent} from './modules/partners/add/add.component';
import {ShowComponent} from './modules/partners/show/show.component';
import {AllFacilitiesListComponent} from './modules/facilities/all-facilities-list/all-facilities-list.component';
import {FacilityDetailsComponent} from './modules/facilities/facility-details/facility-details.component';
import {FacilityAddComponent} from './modules/facilities/facility-add/facility-add.component';
import {AllOfwcasListComponent} from './modules/ofwcas/all-ofwcas-list/all-ofwcas-list.component';
import {OfwcaAddComponent} from './modules/ofwcas/ofwca-add/ofwca-add.component';
import {OfwcaDetailsComponent} from './modules/ofwcas/ofwca-details/ofwca-details.component';
import {
  AllInsuranceCompaniesListComponent
} from './modules/insurance-companies/all-insurance-companies-list/all-insurance-companies-list.component';
import {
  InsuranceCompanyDetailsComponent
} from './modules/insurance-companies/insurance-company-details/insurance-company-details.component';
import {DocumentAddComponent} from './modules/documents/document-add/document-add.component';
import {AllDocumentListComponent} from './modules/documents/all-document-list/all-document-list.component';
import {AllContractListComponent} from './modules/contracts/all-contract-list/all-contract-list.component';
import {ContractAddComponent} from './modules/contracts/contract-add/contract-add.component';
import {ContractDetailsComponent} from './modules/contracts/contract-details/contract-details.component';
import {DocumentDetailsComponent} from './modules/documents/document-details/document-details.component';
import {AllTemplateListComponent} from './modules/templates/all-template-list/all-template-list.component';
import {TemplateAddComponent} from './modules/templates/template-add/template-add.component';
import {TemplateDetailsComponent} from './modules/templates/template-details/template-details.component';
import {TemplatingConfigMapComponent} from './modules/templates/templating-config-map/templating-config-map.component';
import {AllUserListComponent} from './modules/user/all-user-list/all-user-list.component';
import {UserAddComponent} from './modules/user/user-add/user-add.component';
import {UserDetailsComponent} from './modules/user/user-details/user-details.component';
import {AllDepartmentListComponent} from './modules/department/all-department-list/all-department-list.component';
import {DepartmentAddComponent} from './modules/department/department-add/department-add.component';
import {DepartmentDetailsComponent} from './modules/department/department-details/department-details.component';
import {AllKrkListComponent} from './modules/krk/all-krk-list/all-krk-list.component';
import {KrkAddComponent} from './modules/krk/krk-add/krk-add.component';
import {KrkDetailsComponent} from './modules/krk/krk-details/krk-details.component';
import {PendingKrkListComponent} from './modules/krk/pending-krk-list/pending-krk-list.component';
import {
  AllRegistrationsListComponent
} from './modules/registrations/all-registrations-list/all-registrations-list.component';
import {RegistrationAddComponent} from './modules/registrations/registration-add/registration-add.component';
import {
  RegistrationDetailsComponent
} from './modules/registrations/registration-details/registration-details.component';
import {
  AUTHORIZATION_STATUS_TO_GENERATE,
  COMPANY_ASF,
  COMPANY_ASF_PREMIUM, COMPANY_MULTISFERA,
  CONTRACT_STATUS_ACTIVE,
  CONTRACT_STATUS_NEW,
  CONTRACT_STATUS_SENT_WITH_AUTENTI,
  CONTRACT_STATUS_TO_TERMINATE,
  CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS,
  CONTRACT_TYPE_DURING_REGISTRATION,
  CONTRACT_TYPE_FRANCHISE,
  CONTRACT_TYPE_FRANCHISE_AGREEMENT,
  CONTRACT_TYPE_MANDATE,
  CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE,
  CONTRACT_TYPE_MANDATE_ONLY_HEALTH, CONTRACT_TYPE_MANDATE_STUDENT,
  CONTRACT_TYPE_OCK,
  CONTRACT_TYPE_PARTNERSHIP,
  CONTRACT_TYPE_PROFIT,
  CONTRACT_TYPE_SELF_BILLING,
  CONTRACT_TYPE_TERMINAL,
  FILE_TYPE_AUTHORIZATION, FILE_TYPE_AWARD_RECEPTION_PROTOCOL,
  FILE_TYPE_CERT_100P,
  FILE_TYPE_CERT_40P,
  FILE_TYPE_DIPLOMA,
  FILE_TYPE_KRK,
  FORM_ROW_STATUS_LOSS,
  FORM_ROW_STATUS_NEW,
  FORM_ROW_STATUS_SUCCESS,
  FORM_ROW_STATUS_TO_BE_SERVED,
  INVOICE_STATUS_SUSPENDED,
  INVOICE_STATUS_TO_BE_REALIZED,
  LEAVE_APPLICATION_STATUS_ACCEPTED,
  LEAVE_APPLICATION_STATUS_CANCEL,
  LEAVE_APPLICATION_STATUS_FOR_ACCEPTANCE,
  LEAVE_APPLICATION_STATUS_REJECTED,
  MEETING_TYPE_ADA,
  MEETING_TYPE_ENTRANCE_EXAM,
  MEETING_TYPE_EXAM,
  MEETING_TYPE_IDD_TRAINING,
  MEETING_TYPE_MEETING,
  MEETING_TYPE_NEW_AGENT_TRAINING,
  MEETING_TYPE_OTHER,
  MEETING_TYPE_TRAINING,
  PERSONAL_DATA_CHANGE_STATUS_COMPLETED,
  PERSONAL_DATA_CHANGE_STATUS_REPORTED,
  PERSONAL_DATA_CHANGE_STATUS_SENT_TO_IC,
  RECEIVABLES_IMPORT_ROW_STATUS_CANCELLED,
  RECEIVABLES_IMPORT_ROW_STATUS_FOR_VERIFICATION,
  RECEIVABLES_IMPORT_ROW_STATUS_NEW,
  RECEIVABLES_IMPORT_ROW_STATUS_PAID,
  RECEIVABLES_IMPORT_ROW_STATUS_PAYMENT_REPORTED,
  RECEIVABLES_IMPORT_ROW_STATUS_REJECTED,
  RECEIVABLES_IMPORT_ROW_STATUS_TO_CANCELLED,
  RECEIVABLES_IMPORT_ROW_STATUS_UNPAID,
  RECEIVABLES_PAYMENT_STATUS_CANCELED,
  RECEIVABLES_PAYMENT_STATUS_OUTGOING_PAYMENT,
  RECEIVABLES_PAYMENT_STATUS_SETTLED,
  RECEIVABLES_PAYMENT_STATUS_UNSETTLED,
  RECEIVABLES_TRANSFER_STATUS_TO_BE_COMPLETED,
  REGISTRATION_STATUS_BLOCKED,
  REGISTRATION_STATUS_DENIED_BY_INSURANCE_COMPANY,
  REGISTRATION_STATUS_DEREGISTERED,
  REGISTRATION_STATUS_EXAM_PASSED,
  REGISTRATION_STATUS_INCORRECT_DOCUMENTS,
  REGISTRATION_STATUS_REGISTERED,
  REGISTRATION_STATUS_REGISTRATION_REQUEST,
  REGISTRATION_STATUS_RESIGNATION,
  REGISTRATION_STATUS_SENT_TO_BLOCK,
  REGISTRATION_STATUS_SENT_TO_DEREGISTER,
  REGISTRATION_STATUS_SENT_TO_REGISTER_IN_INSURANCE_COMPANY,
  REGISTRATION_STATUS_SIGNED_UP_FOR_AN_EXAM,
  REGISTRATION_STATUS_TO_BLOCK,
  REGISTRATION_STATUS_TO_DEREGISTER,
  SERVICE_TYPE_CORPORATION,
  SERVICE_TYPE_SUPPORT,
  TERMINAL_STATUS_PAID, TERMINAL_STATUS_SUSPENDED,
  TERMINAL_STATUS_TO_BE_REALIZED,
  TERMINALS_IMPORT_ROW_STATUS_FOR_VERIFICATION,
  TERMINALS_IMPORT_ROW_STATUS_SETTLED,
  TERMINALS_IMPORT_ROW_STATUS_UNSETTLED
} from './shared/services/dict.service';
import {
  AllDeregistrationPackListComponent
} from './modules/deregistration-pack/all-deregistration-pack-list/all-deregistration-pack-list.component';
import {
  DeregistrationPackAddComponent
} from './modules/deregistration-pack/deregistration-pack-add/deregistration-pack-add.component';
import {
  DeregistrationPackDetailsComponent
} from './modules/deregistration-pack/deregistration-pack-details/deregistration-pack-details.component';
import {
  AllContractInsuranceCompaniesListComponent
} from './modules/contracts/all-contract-insurance-companies-list/all-contract-insurance-companies-list.component';
import {AllIdentifiersListComponent} from './modules/identifiers/all-identifiers-list/all-identifiers-list.component';
import {IdentifierImportComponent} from './modules/identifiers/identifier-import/identifier-import.component';
import {AllMeetingsListComponent} from './modules/meetings/all-meetings-list/all-meetings-list.component';
import {MeetingAddComponent} from './modules/meetings/meeting-add/meeting-add.component';
import {MeetingDetailsComponent} from './modules/meetings/meeting-details/meeting-details.component';
import {MeetingsCalendarComponent} from './modules/meetings/meetings-calendar/meetings-calendar.component';
import {
  AllIddTrainingsListComponent
} from './modules/idd-trainings/all-idd-trainings-list/all-idd-trainings-list.component';
import {
  AddIddTrainingCertificateComponent
} from './modules/idd-trainings/add-idd-training-certificate/add-idd-training-certificate.component';
import {IddTrainingDetailsComponent} from './modules/idd-trainings/idd-training-details/idd-training-details.component';
import {
  AllIddTrainingCertificatesListComponent
} from './modules/idd-trainings/all-idd-training-certificates-list/all-idd-training-certificates-list.component';
import {
  DecodeIddTrainingCertificatesComponent
} from './modules/idd-trainings/decode-idd-training-certificates/decode-idd-training-certificates.component';
import {AllImportsListComponent} from './modules/identifiers/all-imports-list/all-imports-list.component';
import {SoldPolicyImportComponent} from './modules/sold-policy/sold-policy-import/sold-policy-import.component';
import {
  AllImportsListComponent as AllSoldPolicyImportListComponent
} from './modules/sold-policy/all-imports-list/all-imports-list.component';
import {AllPoliciesListComponent} from './modules/sold-policy/all-policies-list/all-policies-list.component';
import {ReportsComponent} from './modules/sold-policy/reports/reports.component';
import {AllRisksListComponent} from './modules/settlements/risks/all-risks-list/all-risks-list.component';
import {AddRiskComponent} from './modules/settlements/risks/add-risk/add-risk.component';
import {
  AllImportsListComponent as AllCommissionImportListComponent
} from './modules/settlements/imports/all-imports-list/all-imports-list.component';
import {CommissionImportComponent} from './modules/settlements/imports/commission-import/commission-import.component';
import {
  AllCommissionsListComponent
} from './modules/settlements/imports/all-commissions-list/all-commissions-list.component';
import {
  CommissionDetailsComponent
} from './modules/settlements/imports/commission-details/commission-details.component';
import {
  AllRedirectionsListComponent
} from './modules/settlements/redirections/all-redirections-list/all-redirections-list.component';
import {
  RedirectionDetailsComponent
} from './modules/settlements/redirections/redirection-details/redirection-details.component';
import {RedirectionAddComponent} from './modules/settlements/redirections/redirection-add/redirection-add.component';
import {JobsListComponent} from './modules/settlements/jobs-list/jobs-list.component';
import {
  AllSettlementsListComponent
} from './modules/settlements/settlements/all-settlements-list/all-settlements-list.component';
import {
  SettlementDetailsComponent
} from './modules/settlements/settlements/settlement-details/settlement-details.component';
import {
  RedirectionImportComponent
} from './modules/settlements/redirections/redirection-import/redirection-import.component';
import {
  AllRedirectionImportsListComponent
} from './modules/settlements/redirections/all-redirection-imports-list/all-redirection-imports-list.component';
import {
  AllThresholdsListComponent
} from './modules/settlements/thresholds/all-thresholds-list/all-thresholds-list.component';
import {AddThresholdComponent} from './modules/settlements/thresholds/add-threshold/add-threshold.component';
import {AllAnnexesListComponent} from './modules/settlements/annexes/all-annexes-list/all-annexes-list.component';
import {AddAnnexComponent} from './modules/settlements/annexes/add-annex/add-annex.component';
import {
  AllRiskDictsListComponent
} from "./modules/settlements/risk-dicts/all-risk-dicts-list/all-risk-dicts-list.component";
import {AddRiskDictComponent} from "./modules/settlements/risk-dicts/add-risk-dict/add-risk-dict.component";
import {MassEditionComponent} from './modules/settlements/mass-edition/mass-edition.component';
import {AllInvoicesListComponent} from './modules/settlements/invoices/all-invoices-list/all-invoices-list.component';
import {AddInvoiceComponent} from './modules/settlements/invoices/add-invoice/add-invoice.component';
import {InvoiceDetailsComponent} from './modules/settlements/invoices/invoice-details/invoice-details.component';
import {AllPaymentListComponent} from "./modules/settlements/payment/all-payment-list/all-payment-list.component";
import {PaymentHistoryComponent} from "./modules/settlements/payment/payment-history/payment-history.component";
import {NewsletterCurrentComponent} from "./modules/newsletter/newsletter-current/newsletter-current.component";
import {NewsletterListComponent} from "./modules/newsletter/newsletter-list/newsletter-list.component";
import {NewsletterDetailsComponent} from "./modules/newsletter/newsletter-details/newsletter-details.component";
import {NewsletterAddComponent} from "./modules/newsletter/newsletter-add/newsletter-add.component";
import {
  RegistrationsAddMultipleComponent
} from "./modules/registrations/registrations-add-multiple/registrations-add-multiple.component";
import {AllRegionalListComponent} from "./modules/regional/all-regional-list/all-regional-list.component";
import {RegionalDetailsComponent} from "./modules/regional/regional-details/regional-details.component";
import {RegionalAddComponent} from "./modules/regional/regional-add/regional-add.component";
import {
  AddInsuranceCompanyComponent
} from "./modules/insurance-companies/add-insurance-company/add-insurance-company.component";
import {AllSupportListComponent} from "./modules/support/all-support-list/all-support-list.component";
import {SupportAddComponent} from "./modules/support/support-add/support-add.component";
import {SupportDetailsComponent} from "./modules/support/support-details/support-details.component";
import {ReportContractsComponent} from "./modules/analytics/report-contracts/report-contracts.component";
import {ReportIdentifiersComponent} from "./modules/analytics/report-identifiers/report-identifiers.component";
import {ReportOfwcasComponent} from "./modules/analytics/report-ofwcas/report-ofwcas.component";
import {ReportPartnersComponent} from "./modules/analytics/report-partners/report-partners.component";
import {ReportRedirectionComponent} from "./modules/analytics/report-redirection/report-redirection.component";
import {ReportRegistrationsComponent} from "./modules/analytics/report-registrations/report-registrations.component";
import {AllLicensedAgentComponent} from "./modules/agent-21/all-licensed-agent/all-licensed-agent.component";
import {
  AllContractBalanceListComponent
} from "./modules/settlements/contract-balance/all-contract-balance-list/all-contract-balance-list.component";
import {
  ContractBalanceDetailsComponent
} from "./modules/settlements/contract-balance/contract-balance-details/contract-balance-details.component";
import {SearchEngineComponent} from "./modules/partners/search-engine/search-engine.component";
import {OfwcaRegisteredListComponent} from "./modules/meetings/ofwca-registered-list/ofwca-registered-list.component";
import {
  AllSettlementsTemplateListComponent
} from "./modules/settlements/settlemnts-tempate/all-settlements-template-list/all-settlements-template-list.component";
import {AddBillsComponent} from "./modules/settlements/invoices/add-bills/add-bills.component";
import {TuTemplateComponent} from "./modules/identifiers/tu-template/tu-template.component";
import {AllBankFilesListComponent} from "./modules/bank-files/all-bank-files-list/all-bank-files-list.component";
import {
  CommissionMarginReportListComponent
} from "./modules/settlements/commission-margin-report/commission-margin-report-list/commission-margin-report-list.component";
import {AllCorporationListComponent} from "./modules/corporation/all-corporation-list/all-corporation-list.component";
import {CorporationAddComponent} from "./modules/corporation/corporation-add/corporation-add.component";
import {CorporationDetailsComponent} from "./modules/corporation/corporation-details/corporation-details.component";
import {AllPostListComponent} from "./modules/asf360/post/all-post-list/all-post-list.component";
import {PostAddComponent} from "./modules/asf360/post/post-add/post-add.component";
import {AllTagsListComponent} from "./modules/asf360/tags/all-tags-list/all-tags-list.component";
import {TagsAddComponent} from "./modules/asf360/tags/tags-add/tags-add.component";
import {PostDetailsComponent} from "./modules/asf360/post/post-details/post-details.component";
import {
  AllPermissionTagsListComponent
} from "./modules/asf360/permission-tags/all-permission-tags-list/all-permission-tags-list.component";
import {
  PermissionTagsAddComponent
} from "./modules/asf360/permission-tags/permission-tags-add/permission-tags-add.component";
import {
  PermissionTagsDetailsComponent
} from "./modules/asf360/permission-tags/permission-tags-details/permission-tags-details.component";
import {
  AllSelfBillingFormListComponent
} from "./modules/self-billing-form/all-self-billing-form-list/all-self-billing-form-list.component";
import {AllAddressImportComponent} from "./modules/address-imports/all-address-import/all-address-import.component";
import {
  AllAddressImportRowComponent
} from "./modules/address-imports/all-address-import-row/all-address-import-row.component";
import {TagsDetailsComponent} from "./modules/asf360/tags/tags-details/tags-details.component";
import {
  AllDynamicDictionaryListComponent
} from "./modules/dynamic-dictionary/all-dynamic-dictionary-list/all-dynamic-dictionary-list.component";
import {
  DynamicDictionaryAddComponent
} from "./modules/dynamic-dictionary/dynamic-dictionary-add/dynamic-dictionary-add.component";
import {
  DynamicDictionaryDetailsComponent
} from "./modules/dynamic-dictionary/dynamic-dictionary-details/dynamic-dictionary-details.component";
import {CalendarComponent} from "./modules/meetings/calendar/calendar.component";
import {AddressAddComponent} from "./modules/address-imports/address-add/address-add.component";
import {
  OfwcasMissingDocumentsComponent
} from "./modules/ofwcas/ofwcas-missing-documents/ofwcas-missing-documents.component";
import {ReportListComponent} from "./modules/analytics/report-list/report-list.component";
import {DynamicFormListComponent} from "./modules/dynamic-forms/dynamic-form-list/dynamic-form-list.component";
import {AddDynamicFormComponent} from "./modules/dynamic-forms/add-dynamic-form/add-dynamic-form.component";
import {
  DynamicFormsDetailsComponent
} from "./modules/dynamic-forms/dynamic-forms-details/dynamic-forms-details.component";
import {
  DynamicFormApplyListComponent
} from "./modules/dynamic-forms/dynamic-form-apply-list/dynamic-form-apply-list.component";
import {
  AllReceivablesImportsListComponent
} from "./modules/receivables/imports/all-receivables-imports-list/all-receivables-imports-list.component";
import {
  ReceivablesImportComponent
} from "./modules/receivables/imports/receivables-import/receivables-import.component";
import {
  AllReceivablesImportsRowListComponent
} from "./modules/receivables/imports-row/all-receivables-imports-row-list/all-receivables-imports-row-list.component";
import {
  ReceivablesImportsRowDetailsComponent
} from "./modules/receivables/imports-row/receivables-imports-row-details/receivables-imports-row-details.component";
import {
  ReceivablesJobListComponent
} from "./modules/receivables/generat/receivables-job-list/receivables-job-list.component";
import {
  AllReceivablesBalanceListComponent
} from "./modules/receivables/balance/all-receivables-balance-list/all-receivables-balance-list.component";
import {
  ReceivablesPaymentImportComponent
} from "./modules/receivables/payment/receivables-payment-import/receivables-payment-import.component";
import {
  AllReceivablesPaymentImportListComponent
} from "./modules/receivables/payment/all-receivables-payment-import-list/all-receivables-payment-import-list.component";
import {
  AllReceivablesPaymentImportRowListComponent
} from "./modules/receivables/payment/all-receivables-payment-import-row-list/all-receivables-payment-import-row-list.component";
import {
  ReceivablesPaymentImportRowDetailsComponent
} from "./modules/receivables/payment/receivables-payment-import-row-details/receivables-payment-import-row-details.component";
import {
  ReceivablesBalanceDetailsComponent
} from "./modules/receivables/balance/receivables-balance-details/receivables-balance-details.component";
import {EmailSendAddComponent} from "./modules/email-send/email-send-add/email-send-add.component";
import {EmailSendJobListComponent} from "./modules/email-send/email-send-job-list/email-send-job-list.component";
import {EmailSendDetailsComponent} from "./modules/email-send/email-send-details/email-send-details.component";
import {
  ReceivablesPaymentImportRowAddComponent
} from "./modules/receivables/payment/receivables-payment-import-row-add/receivables-payment-import-row-add.component";
import {
  IddTrainingsTrainerListComponent
} from "./modules/idd-trainings/idd-trainings-trainer-list/idd-trainings-trainer-list.component";
import {
  AddIddTrainingsTrainerComponent
} from "./modules/idd-trainings/add-idd-trainings-trainer/add-idd-trainings-trainer.component";
import {
  IddTrainingsTrainerDetailsComponent
} from "./modules/idd-trainings/idd-trainings-trainer-details/idd-trainings-trainer-details.component";
import {AllNoteListComponent} from "./modules/note/all-note-list/all-note-list.component";
import {NoteAddComponent} from "./modules/note/note-add/note-add.component";
import {NoteDetailsComponent} from "./modules/note/note-details/note-details.component";
import {OckUserListComponent} from "./modules/ock/ock-user-list/ock-user-list.component";
import {OckPolicyListComponent} from "./modules/ock/ock-policy-list/ock-policy-list.component";
import {OckCompanyListComponent} from "./modules/ock/ock-company-list/ock-company-list.component";
import {AllOckImportListComponent} from "./modules/ock/all-ock-import-list/all-ock-import-list.component";
import {AllNipListComponent} from "./modules/ock/all-nip-list/all-nip-list.component";
import {AllVinListComponent} from "./modules/ock/all-vin-list/all-vin-list.component";
import {NipAddComponent} from "./modules/ock/nip-add/nip-add.component";
import {VinAddComponent} from "./modules/ock/vin-add/vin-add.component";
import {
  CommissionUpdatePackageListComponent
} from "./modules/settlements/commission-update-package/commission-update-package-list/commission-update-package-list.component";
import {
  CommissionUpdatePackageDetailsComponent
} from "./modules/settlements/commission-update-package/commission-update-package-details/commission-update-package-details.component";
import {
  CommissionUpdatePackageAddComponent
} from "./modules/settlements/commission-update-package/commission-update-package-add/commission-update-package-add.component";
import {AllTerminalsListComponent} from "./modules/terminals/all-terminals-list/all-terminals-list.component";
import {LicensedDetailsComponent} from "./modules/agent-21/licensed-details/licensed-details.component";
import {TerminalsDetailsComponent} from "./modules/terminals/terminals-details/terminals-details.component";
import {TerminalsImportComponent} from "./modules/terminals/imports/terminals-import/terminals-import.component";
import {
  AllTerminalsImportsListComponent
} from "./modules/terminals/imports/all-terminals-imports-list/all-terminals-imports-list.component";
import {
  AllTerminalsImportsRowListComponent
} from "./modules/terminals/imports-row/all-terminals-imports-row-list/all-terminals-imports-row-list.component";
import {
  TerminalsImportsRowDetailsComponent
} from "./modules/terminals/imports-row/terminals-imports-row-details/terminals-imports-row-details.component";
import {
  TerminalsBankJobListComponent
} from "./modules/terminals/bankJob/terminals-bank-job-list/terminals-bank-job-list.component";
import {
  AffiliateCodeDetailsComponent
} from "./modules/affiliate-code/affiliate-code-details/affiliate-code-details.component";
import {FileManagerListComponent} from "./modules/file-manager/file-manager-list/file-manager-list.component";
import {AllTagListComponent} from "./modules/file-manager/tag/all-tag-list/all-tag-list.component";
import {
  AllSharedFileListComponent
} from "./modules/file-manager/shared-file/all-shared-file-list/all-shared-file-list.component";
import {AddPageComponent} from "./modules/file-manager/page/add-page/add-page.component";
import {PageListComponent} from "./modules/file-manager/page/page-list/page-list.component";
import {PageDetailsComponent} from "./modules/file-manager/page/page-details/page-details.component";
import {
  AllPersonalDataChangeListComponent
} from "./modules/personal-data-change/all-personal-data-change-list/all-personal-data-change-list.component";
import {
  PersonalDataChangeDetailsComponent
} from "./modules/personal-data-change/personal-data-change-details/personal-data-change-details.component";
import {
  AllIddTrainingCertificatesToCheckListComponent
} from "./modules/idd-trainings/all-idd-training-certificates-to-check-list/all-idd-training-certificates-to-check-list.component";
import {ChroniePaymentListComponent} from "./modules/chronie/chronie-payment-list/chronie-payment-list.component";
import {ChronieJobListComponent} from "./modules/chronie/chronie-job-list/chronie-job-list.component";
import {TransferAddComponent} from "./modules/receivables/transfer/transfer-add/transfer-add.component";
import {TransferListComponent} from "./modules/receivables/transfer/transfer-list/transfer-list.component";
import {
  TransferBankJobListComponent
} from "./modules/receivables/transfer/transfer-bank-job-list/transfer-bank-job-list.component";
import {TransferDetailsComponent} from "./modules/receivables/transfer/transfer-details/transfer-details.component";
import {
  AllCommissionImportRowSettledListComponent
} from "./modules/settlements/commission-import-row-settled/all-commission-import-row-settled-list/all-commission-import-row-settled-list.component";
import {AllBlockedNipListComponent} from "./modules/partners/all-blocked-nip-list/all-blocked-nip-list.component";
import {AllEmployeeListComponent} from "./modules/hr/employee/all-employee-list/all-employee-list.component";
import {EmployeeDetailsComponent} from "./modules/hr/employee/employee-details/employee-details.component";
import {
  LeaveApplicationDetailsComponent
} from "./modules/hr/leave/leave-application-details/leave-application-details.component";
import {
  AllLeaveApplicationListComponent
} from "./modules/hr/leave/all-leave-application-list/all-leave-application-list.component";
import {AllLicenseListComponent} from "./modules/license/all-license-list/all-license-list.component";
import {LicenseDetailsComponent} from "./modules/license/license-details/license-details.component";
import {UserLicensesDetailsComponent} from "./modules/license/user-licenses-details/user-licenses-details.component";
import {AllDeviceListComponent} from "./modules/license/all-device-list/all-device-list.component";
import {DeviceDetailsComponent} from "./modules/license/device-details/device-details.component";
import {
  AllWarehouseProductListComponent
} from "./modules/warehouse/all-warehouse-product-list/all-warehouse-product-list.component";
import {
  WarehouseProductDetailsComponent
} from "./modules/warehouse/warehouse-product-details/warehouse-product-details.component";
import {
  CompetitionDataImportComponent
} from "./modules/competition-import/competition-data-import/competition-data-import.component";
import {
  AdditionalFieldsListComponent
} from "./modules/additional-fields/additional-fields-list/additional-fields-list.component";
import {
  CompetitionImportListComponent
} from "./modules/competition-import/competition-import-list/competition-import-list.component";
import {
  AdditionalFieldsDetailsComponent
} from "./modules/additional-fields/additional-fields-details/additional-fields-details.component";
import {
  CompetitionImportValuesListComponent
} from "./modules/competition-import/competition-import-values-list/competition-import-values-list.component";
import {
  CompetitionImportRowDetailsComponent
} from "./modules/competition-import/competition-import-row-details/competition-import-row-details.component";
import {
  CompetitionImportRowListComponent
} from "./modules/competition-import/competition-import-row-list/competition-import-row-list.component";
import {
  ReceivablesPaymentImportTransferAddComponent
} from "./modules/receivables/payment/receivables-payment-import-transfer-add/receivables-payment-import-transfer-add.component";
import {CompetitionWzListComponent} from "./modules/competition-wz/competition-wz-list/competition-wz-list.component";
import {
  CompetitionWzRowsListComponent
} from "./modules/competition-wz/competition-wz-rows-list/competition-wz-rows-list.component";
import {LogDeletedDataListComponent} from "./modules/log-deleted-data/log-deleted-data-list/log-deleted-data-list.component";
import {
  DobryAgentNotificationSettingsComponent
} from "./modules/dobry-agent/dobry-agent-notification-settings/dobry-agent-notification-settings.component";
import {InvoiceDocumentListComponent} from "./modules/settlements/invoices/invoice-document/invoice-document-list/invoice-document-list.component";
import {InvoiceDocumentCreateComponent} from "./modules/settlements/invoices/invoice-document/invoice-document-create/invoice-document-create.component";
import {
  InvoiceDocumentDetailsComponent
} from "./modules/settlements/invoices/invoice-document/invoice-document-details/invoice-document-details.component";
import {InvoiceGeneratorComponent} from "./modules/settlements/invoices/invoice-generator/invoice-generator.component";
import {
  DynamicDictionaryImportComponent
} from "./modules/dynamic-dictionary/dynamic-dictionary-import/dynamic-dictionary-import.component";
import {AllLoginLockListComponent} from "./modules/login-lock/all-login-lock-list/all-login-lock-list.component";
import {
  AllPartnerTagsImportComponent
} from "./modules/partner-tags/all-partner-tags-import/all-partner-tags-import.component";
import {
  HiperioRegistrationConfigDetailsComponent
} from "./modules/agents-profile-hiperio/hiperio-registration-config-details/hiperio-registration-config-details.component";
import {
  CredentialsJobsListComponent
} from "./modules/agents-profile-hiperio/credentials-jobs-list/credentials-jobs-list.component";
import {UserJobsListComponent} from "./modules/agents-profile-hiperio/user-jobs-list/user-jobs-list.component";
import {
  HiperioTestAccessFormListComponent
} from "./modules/agents-profile-hiperio/hiperio-test-access-form-list/hiperio-test-access-form-list.component";
import {
  HiperioConcludeChangeRegistrationComponent
} from "./modules/agents-profile-hiperio/hiperio-conclude-change-registration/hiperio-conclude-change-registration.component";
import {
  HiperioConfigDirectListComponent
} from "./modules/chronie/hiperio-config-direct-list/hiperio-config-direct-list.component";
import {
  HiperioConfigDirectDetailsComponent
} from "./modules/chronie/hiperio-config-direct-details/hiperio-config-direct-details.component";
import {DaArticleListComponent} from "./modules/dobry-agent/blog/da-article-list/da-article-list.component";
import {DaArticleDetailsComponent} from "./modules/dobry-agent/blog/da-article-details/da-article-details.component";
import {DaArticleAddComponent} from "./modules/dobry-agent/blog/da-article-add/da-article-add.component";
import {DaCategoryListComponent} from "./modules/dobry-agent/blog/da-category-list/da-category-list.component";
import {DaCategoryAddComponent} from "./modules/dobry-agent/blog/da-category-add/da-category-add.component";
import {DaTagListComponent} from "./modules/dobry-agent/blog/da-tag-list/da-tag-list.component";
import {DaAuthorListComponent} from "./modules/dobry-agent/blog/da-author-list/da-author-list.component";
import {DaAuthorDetailsComponent} from "./modules/dobry-agent/blog/da-author-details/da-author-details.component";
import {DaAuthorAddComponent} from "./modules/dobry-agent/blog/da-author-add/da-author-add.component";
import {DaCategoryDetailsComponent} from "./modules/dobry-agent/blog/da-category-details/da-category-details.component";
import {DaTagDetailsComponent} from "./modules/dobry-agent/blog/da-tag-details/da-tag-details.component";
import {DaTagAddComponent} from "./modules/dobry-agent/blog/da-tag-add/da-tag-add.component";

import {
  AllCommissionTablesListComponent
} from "./modules/settlements/commission-tables/all-commission-tables-list/all-commission-tables-list.component";
import {AddCommissionTableComponent} from "./modules/settlements/commission-tables/add-commission-table/add-commission-table.component";
import {
  CommissionTableDetailsComponent
} from "./modules/settlements/commission-tables/commission-table-details/commission-table-details.component";
import {AllImportContactsComponent} from "./modules/import-contacts/all-import-contacts/all-import-contacts.component";
import {ChronieAllMaintenanceWindowListComponent} from "./modules/chronie/chronie-maintenance-window/chronie-all-maintenance-window-list/chronie-all-maintenance-window-list.component";
import {ChronieMaintenanceWindowViewComponent} from "./modules/chronie/chronie-maintenance-window/chronie-maintenance-window-view/chronie-maintenance-window-view.component";
import {ChronieMaintenanceWindowAddComponent} from "./modules/chronie/chronie-maintenance-window/chronie-maintenance-window-add/chronie-maintenance-window-add.component";
import {
  ChronieMaintenanceWindowDetailsComponent
} from "./modules/chronie/chronie-maintenance-window/chronie-maintenance-window-details/chronie-maintenance-window-details.component";
const routes: Routes = [
  {path: '', component: ListComponent},
  {path: 'partnerzy', component: ListComponent},
  {path: 'partnerzy/szczegoly/:id', component: ShowComponent},
  {path: 'partnerzy/dodaj', component: AddComponent},
  {path: 'partnerzy/wyszukiwarka', component: SearchEngineComponent},
  {path: 'partnerzy/zablokowane-nip', component: AllBlockedNipListComponent},

  {path: 'placowki', component: AllFacilitiesListComponent},
  {path: 'placowki/dodaj', component: FacilityAddComponent},
  {path: 'placowki/szczegoly/:id', component: FacilityDetailsComponent},

  {path: 'ofwca', component: AllOfwcasListComponent},
  {path: 'ofwca/dodaj', component: OfwcaAddComponent},
  {path: 'ofwca/szczegoly/:id', component: OfwcaDetailsComponent},

  {path: 'tu', component: AllInsuranceCompaniesListComponent},
  {path: 'tu/szczegoly/:id', component: InsuranceCompanyDetailsComponent},
  {path: 'tu/dodaj', component: AddInsuranceCompanyComponent},

  {path: 'dokumenty', component: AllDocumentListComponent, data: {excludeColumns: ['product']}},
  {path: 'dokumenty/dodaj', component: DocumentAddComponent},
  {path: 'dokumenty/szczegoly/:id', component: DocumentDetailsComponent},
  {path: 'dokumenty/rejestracje', component: AllDocumentListComponent, data: {
      typeKeys: [FILE_TYPE_KRK, FILE_TYPE_CERT_100P, FILE_TYPE_CERT_40P, FILE_TYPE_AUTHORIZATION, FILE_TYPE_DIPLOMA],
      masterModule: 'Rejestracje', excludeColumns: ['product']}},
  {path: 'dokumenty/rejestracje/dodaj', component: DocumentAddComponent, data: {
      masterModule: 'Rejestracje',
    }},
  {path: 'dokumenty/rejestracje/szczegoly/:id', component: DocumentDetailsComponent},

  {path: 'umowy', component: AllContractListComponent},
  {path: 'umowy/zalaczniki-tu', component: AllContractInsuranceCompaniesListComponent},
  {path: 'umowy/nowe-zalaczniki-tu', component: AllContractInsuranceCompaniesListComponent, data: {
      statusKeys: [CONTRACT_STATUS_NEW, CONTRACT_STATUS_SENT_WITH_AUTENTI, CONTRACT_STATUS_ACTIVE],
      sent: 0,
      signed: 0,
      returned: 0,
      onlyNew: 1,
    }},
  {path: 'umowy/nowe', component: AllContractListComponent, data: {
      statusKey: [CONTRACT_STATUS_NEW],
      typeKey: [
        CONTRACT_TYPE_OCK,
        CONTRACT_TYPE_PARTNERSHIP,
        CONTRACT_TYPE_MANDATE,
        CONTRACT_TYPE_MANDATE_ONLY_HEALTH,
        CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE,
        CONTRACT_TYPE_PROFIT,
        CONTRACT_TYPE_DURING_REGISTRATION,
        CONTRACT_TYPE_MANDATE_STUDENT,
      ],
    }},
  {path: 'umowy/finansowe', component: AllContractListComponent, data: {
      statusKey: [CONTRACT_STATUS_NEW],
      typeKey: [CONTRACT_TYPE_TERMINAL],
    }},
  {path: 'umowy/dobry-agent', component: AllContractListComponent, data: {
      statusKey: [CONTRACT_STATUS_NEW],
      typeKey: [CONTRACT_TYPE_FRANCHISE, CONTRACT_TYPE_FRANCHISE_AGREEMENT, CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS ],
    }},
  {path: 'umowy/samofakturowanie', component: AllContractListComponent, data: {
      statusKey: [CONTRACT_STATUS_NEW ], selfBillingWithActiveParent: 1,
      typeKey: [CONTRACT_TYPE_SELF_BILLING ],
    }},
  {path: 'umowy/do-rozwiazania', component: AllContractListComponent, data: { statusKey: [CONTRACT_STATUS_TO_TERMINATE], typeKey: [CONTRACT_TYPE_OCK, CONTRACT_TYPE_PARTNERSHIP, CONTRACT_TYPE_MANDATE, CONTRACT_TYPE_MANDATE_COMPLETE_PACKAGE, CONTRACT_TYPE_MANDATE_ONLY_HEALTH, CONTRACT_TYPE_PROFIT,  CONTRACT_TYPE_MANDATE_STUDENT,], displayedColumns: ['number', 'type', 'concludeDate', 'owner', 'party', 'status', 'terminationReason', 'activeTo', 'assetsRegional', 'company', 'actions']}},
  {path: 'umowy/do-rozwiazania-finansowe', component: AllContractListComponent, data: { statusKey: [CONTRACT_STATUS_TO_TERMINATE], typeKey: [ CONTRACT_TYPE_TERMINAL], displayedColumns: ['number', 'type', 'concludeDate', 'owner', 'party', 'status', 'terminationReason', 'activeTo', 'assetsRegional', 'company', 'actions']}},
  {path: 'umowy/do-rozwiazania-dobry-agent', component: AllContractListComponent, data: { statusKey: [CONTRACT_STATUS_TO_TERMINATE], typeKey: [CONTRACT_TYPE_FRANCHISE, CONTRACT_TYPE_FRANCHISE_AGREEMENT, CONTRACT_TYPE_AGREEMENT_FOR_PARTNER_POINTS ], displayedColumns: ['number', 'type', 'concludeDate', 'owner', 'party', 'status', 'terminationReason', 'activeTo', 'assetsRegional', 'company', 'actions']}},
  {path: 'umowy/do-rozwiazania-samofakturowanie', component: AllContractListComponent, data: { statusKey: [CONTRACT_STATUS_TO_TERMINATE], typeKey: [CONTRACT_TYPE_SELF_BILLING ], displayedColumns: ['number', 'type', 'concludeDate', 'owner', 'party', 'status', 'terminationReason', 'activeTo', 'assetsRegional', 'company', 'actions']}},
  {path: 'umowy/dodaj', component: ContractAddComponent},
  {path: 'umowy/szczegoly/:id', component: ContractDetailsComponent},
  {path: 'umowy/zgloszenia-samofakturowanie', component: AllSelfBillingFormListComponent},


  {path: 'dokumenty/rejestracje/szablony', component: AllTemplateListComponent},
  {path: 'dokumenty/rejestracje/szablony/dodaj', component: TemplateAddComponent},
  {path: 'dokumenty/rejestracje/szablony/szczegoly/:id', component: TemplateDetailsComponent},
  {path: 'dokumenty/rejestracje/szablony/konfiguracja', component: TemplatingConfigMapComponent},

  {path: 'dokumenty/szablony', component: AllTemplateListComponent},
  {path: 'dokumenty/szablony/dodaj', component: TemplateAddComponent},
  {path: 'dokumenty/szablony/szczegoly/:id', component: TemplateDetailsComponent},
  {path: 'dokumenty/szablony/konfiguracja', component: TemplatingConfigMapComponent},

  {path: 'uzytkownicy', component: AllUserListComponent,
    data: {excludeColumns: ['licenseFullName']}},
  {path: 'uzytkownicy/dodaj', component: UserAddComponent},
  {path: 'uzytkownicy/szczegoly/:id', component: UserDetailsComponent},

  {path: 'uzytkownicy/dzialy', component: AllDepartmentListComponent},
  {path: 'uzytkownicy/dzialy/dodaj', component: DepartmentAddComponent},
  {path: 'uzytkownicy/dzialy/szczegoly/:id', component: DepartmentDetailsComponent},

  {path: 'uzytkownicy/regionalni', component: AllRegionalListComponent},
  {path: 'uzytkownicy/regionalni/dodaj', component: RegionalAddComponent},
  {path: 'uzytkownicy/regionalni/szczegoly/:id', component: RegionalDetailsComponent},

  {path: 'uzytkownicy/blokada-logowania', component: AllLoginLockListComponent},


  {path: 'notatki', component: AllNoteListComponent},
  {path: 'notatki/dodaj', component: NoteAddComponent},
  {path: 'notatki/szczegoly/:id', component: NoteDetailsComponent},

  {path: 'licencje-agent21', component: AllLicensedAgentComponent},
  {path: 'licencje-agent21/szczegoly/:id', component: LicensedDetailsComponent},

  {path: 'pracownicy', component: AllUserListComponent,
    data: {active: 1, limitedView: true, roleNot: "ROLE_ASF360", displayedColumns: ['firstName', 'lastName', 'phone', 'email']}},
  {path: 'krk', component: AllKrkListComponent},
  {path: 'krk/do-wyrobienia', component: PendingKrkListComponent},
  {path: 'krk/dodaj', component: KrkAddComponent},
  {path: 'krk/szczegoly/:id', component: KrkDetailsComponent},

  {path: 'rejestracje', component: AllRegistrationsListComponent,
    data: {reportConsents: 1, excludeColumns: ['ofwca_just', 'insuranceCompany_just', 'agreedToDeregister', 'activeKrk',
        'passedExam100p', 'passedExam40p', 'signedUpForAnExam', 'examPassed', 'sentToRegister', 'deregistrationPack',
        'trainingRequirement', 'requirementMet']}},
  {path: 'rejestracje/dodaj', component: RegistrationAddComponent},
  {path: 'rejestracje/dodaj-wiele', component: RegistrationsAddMultipleComponent},
  {path: 'rejestracje/szczegoly/:id', component: RegistrationDetailsComponent},
  {path: 'rejestracje/do-zapisania-na-egzamin', component: AllRegistrationsListComponent,
    data: {hasDiploma: 1, statements: 1, activeContract: 1, canSignUpForAnExam: 1, statusKeys: [REGISTRATION_STATUS_REGISTRATION_REQUEST],
      excludeColumns: ['ofwca_just', 'ofwcaLastName', 'agreedToDeregister', 'statements', 'passedExam100p',
        'insuranceCompany_just', 'passedExam40p', 'signedUpForAnExam', 'examPassed', 'sentToRegister',
        'deregistrationPack', 'trainingRequirement', 'requirementMet']}},
  {path: 'rejestracje/do-zarejestrowania-w-tu', component: AllRegistrationsListComponent,
    data: {hasDiploma: 1, statements: 1, activeKrk: 1, statusKeys: REGISTRATION_STATUS_EXAM_PASSED, canSignUpForAnExam: 1,
      excludeColumns: ['ofwca_just', 'ofwcaLastName', 'agreedToDeregister', 'statements', 'missingExam',
        'insuranceCompany_just', 'passedExam100p', 'passedExam40p', 'signedUpForAnExam', 'examPassed',
        'sentToRegister', 'deregistrationPack', 'trainingRequirement', 'requirementMet']}},
  {path: 'rejestracje/do-zablokowania', component: AllRegistrationsListComponent,
    data: {statusKeys: [
        REGISTRATION_STATUS_TO_BLOCK,
        REGISTRATION_STATUS_SENT_TO_BLOCK,
        REGISTRATION_STATUS_BLOCKED,
        REGISTRATION_STATUS_TO_DEREGISTER,
        REGISTRATION_STATUS_SENT_TO_DEREGISTER,
        REGISTRATION_STATUS_DEREGISTERED,
      ], blockedView: true, blocked: 0,
      displayColumns: [ 'name', 'ofwca', 'insuranceCompany', 'insuranceCompanyType',
        'status', 'company', 'partner', 'assetsRegional', 'sentToBlock', 'blocked', 'contractActiveTo', 'actions']}},
  {path: 'rejestracje/status-egzaminow', component: AllRegistrationsListComponent,
    data: {statusKeys: [
        REGISTRATION_STATUS_EXAM_PASSED,
        REGISTRATION_STATUS_SIGNED_UP_FOR_AN_EXAM,
      ], blockedView: true, blocked: 0,
      displayColumns: [ 'name', 'ofwca', 'insuranceCompany', 'status', 'company', 'dateOfRegistrationForTheExam',
       'dateOfStartTheExam',  'statusExam',  'examType', 'assetsRegional']}},
  {path: 'rejestracje/do-wyrejestrowania', component: AllRegistrationsListComponent,
    data: {statusKeys: REGISTRATION_STATUS_TO_DEREGISTER, showAddToPackAction: true,
      displayColumns: [  'name', 'ofwca', 'rauNumber', 'insuranceCompany',
        'insuranceCompanyType', 'status', 'agreedToDeregister', 'deregistrationPack', 'company', 'partner',
        'assetsRegional', 'insuranceCompany_just', 'actions']}},
  {path: 'rejestracje/w-trakcie', component: AllRegistrationsListComponent,
    data: {statusKeys: [
        REGISTRATION_STATUS_REGISTRATION_REQUEST,
        REGISTRATION_STATUS_SIGNED_UP_FOR_AN_EXAM,
        REGISTRATION_STATUS_EXAM_PASSED,
        REGISTRATION_STATUS_SENT_TO_REGISTER_IN_INSURANCE_COMPANY,
        REGISTRATION_STATUS_INCORRECT_DOCUMENTS,
      ],
      excludeColumns: ['ofwca_just', 'ofwcaLastName', 'insuranceCompany_just', 'agreedToDeregister', 'missingExam',
        'insuranceCompanyType', 'company', 'partner', 'assetsRegional', 'deregistrationPack', 'trainingRequirement', 'requirementMet']}},
  {path: 'rejestracje/upowaznienia-do-wygenerowania', component: AllRegistrationsListComponent,
    data: {statusKeys: [
        REGISTRATION_STATUS_REGISTERED,
      ], authorizationStatusKey: AUTHORIZATION_STATUS_TO_GENERATE,
      excludeColumns: ['ofwca_just', 'ofwcaLastName', 'insuranceCompanyType', 'insuranceCompany_just',
        'status', 'passedExam100p', 'statements', 'activeKrk', 'signedUpForAnExam',
        'examPassed', 'passedExam40p', 'sentToRegister', 'agreedToDeregister', 'deregistrationPack',
        'missingExam', 'trainingRequirement', 'requirementMet']}},
  // {path: 'rejestracje/profile-sprzedazowe', component: AllSalesProfilesListComponent},

  {path: 'rejestracje/do-weryfikacji-pzu', component: AllRegistrationsListComponent,
    data: {statusKeys: [REGISTRATION_STATUS_EXAM_PASSED, REGISTRATION_STATUS_REGISTRATION_REQUEST],
      insuranceCompanyId: 18, activeContract: 1, hasDiploma: 1, statements: 1, passedExam100p: 1,
      registrationFacilityAddressPzu: 1, displayColumns: ['name', 'ofwca', 'insuranceCompany', 'insuranceCompanyType',
        'status', 'company', 'sentToPzuForVerification', 'pzuVerificationSupplement', 'agreedToRegisterInPzu']}},
  {path: 'rejestracje/do-weryfikacji-pzu-zycie', component: AllRegistrationsListComponent,
    data: {statusKeys: [REGISTRATION_STATUS_EXAM_PASSED, REGISTRATION_STATUS_REGISTRATION_REQUEST],
      insuranceCompanyId: 36, activeContract: 1, hasDiploma: 1, statements: 1, passedExam100p: 1,
      displayColumns: ['name', 'ofwca', 'insuranceCompany', 'insuranceCompanyType',
        'status', 'company', 'sentToPzuForVerification', 'pzuVerificationSupplement', 'agreedToRegisterInPzu']}},
  {path: 'brakujace_dokumenty', component: OfwcasMissingDocumentsComponent, data: {
      val: true,
    }},

  {path: 'podwojna-rejestracje/w-trakcie', component: AllRegistrationsListComponent,
    data: {registrationIdTypeSent: 1,  statusKeys: [REGISTRATION_STATUS_REGISTRATION_REQUEST,
      REGISTRATION_STATUS_SIGNED_UP_FOR_AN_EXAM, REGISTRATION_STATUS_EXAM_PASSED,
      REGISTRATION_STATUS_SENT_TO_REGISTER_IN_INSURANCE_COMPANY],
      excludeColumns: ['ofwca_just', 'insuranceCompany_just', 'agreedToDeregister', 'activeKrk',
        'passedExam100p', 'passedExam40p', 'signedUpForAnExam', 'examPassed', 'sentToRegister',
        'deregistrationPack', 'trainingRequirement', 'requirementMet']}},

  {path: 'podwojna-rejestracje/do_weryfikacji', component: AllRegistrationsListComponent,
    data: {registrationIdTypeSent: 1,  statusKeys: [REGISTRATION_STATUS_DENIED_BY_INSURANCE_COMPANY,
        REGISTRATION_STATUS_RESIGNATION],
      excludeColumns: ['ofwca_just', 'insuranceCompany_just', 'agreedToDeregister', 'activeKrk',
        'passedExam100p', 'passedExam40p', 'signedUpForAnExam', 'examPassed', 'sentToRegister', 'deregistrationPack',
        'trainingRequirement', 'requirementMet']}},

  {path: 'wyrejestrowania', component: AllDeregistrationPackListComponent},
  {path: 'wyrejestrowania/dodaj', component: DeregistrationPackAddComponent},
  {path: 'wyrejestrowania/szczegoly/:id', component: DeregistrationPackDetailsComponent},

  {path: 'identyfikatory', component: AllIdentifiersListComponent},
  {path: 'identyfikatory/importy', component: AllImportsListComponent, data: {excludeColumns: ['linkName', 'ofwca', 'partner', 'affiliateLink']}},
  {path: 'identyfikatory/import', component: IdentifierImportComponent},
  {path: 'identyfikatory/szablon-email', component: TuTemplateComponent},

  {path: 'egzaminy-szkolenia/egzaminy', component: AllMeetingsListComponent, data: {
      tableFor: 'Egzamin',
      name: 'Egzaminy',
      displayedColumns: ['meeting', 'logo', 'insuranceCompany', 'startsAt',
        'status', 'examType', 'place', 'linkOrAddress', 'limitOfPeople'],
      typeKey: [MEETING_TYPE_EXAM, MEETING_TYPE_ENTRANCE_EXAM],
    }},
  {path: 'egzaminy-szkolenia/kalendarz', component: MeetingsCalendarComponent},
  {path: 'egzaminy-szkolenia/dodaj', component: MeetingAddComponent, data: {
    name: 'Egzaminy', typeOnlyKeys: [MEETING_TYPE_EXAM, MEETING_TYPE_ENTRANCE_EXAM]
    }},
  {path: 'szkolenie/szkoleniowcy/dodaj', component: AddIddTrainingsTrainerComponent},
  {path: 'szkolenie/szkoleniowcy', component: IddTrainingsTrainerListComponent},
  {path: 'szkolenie/szkoleniowcy/szczegoly/:id', component: IddTrainingsTrainerDetailsComponent},
  {path: 'egzaminy-szkolenia/szczegoly/:id', component: MeetingDetailsComponent},
  {path: 'egzaminy-szkolenia/zapisane-na-egzamin', component: OfwcaRegisteredListComponent, data: {
      typeKey: [MEETING_TYPE_EXAM, MEETING_TYPE_ENTRANCE_EXAM],
      name: 'Egzaminy'
    }},

  {path: 'szkolenie', component: AllMeetingsListComponent, data: {
      tableFor: 'Szkolenie',
      name: 'Szkolenia',
      displayedColumns: ['meeting', 'logo', 'insuranceCompany', 'leader', 'startsAt', 'status', 'place', 'linkOrAddress'],
      typeKey: [MEETING_TYPE_IDD_TRAINING, MEETING_TYPE_NEW_AGENT_TRAINING, MEETING_TYPE_ADA, MEETING_TYPE_TRAINING, MEETING_TYPE_MEETING,
        MEETING_TYPE_OTHER, MEETING_TYPE_NEW_AGENT_TRAINING],
    }},
  {path: 'szkolenie/dodaj', component: MeetingAddComponent, data: {
      name: 'Szkolenia',
      typeOnlyKeys: [MEETING_TYPE_IDD_TRAINING, MEETING_TYPE_NEW_AGENT_TRAINING, MEETING_TYPE_ADA,
        MEETING_TYPE_TRAINING, MEETING_TYPE_MEETING, MEETING_TYPE_OTHER, MEETING_TYPE_NEW_AGENT_TRAINING]
    }},
  {path: 'szkolenie/zapisane-na-szkolenia', component: OfwcaRegisteredListComponent, data: {
      typeKey: [MEETING_TYPE_IDD_TRAINING, MEETING_TYPE_NEW_AGENT_TRAINING, MEETING_TYPE_ADA, MEETING_TYPE_TRAINING, MEETING_TYPE_MEETING,
        MEETING_TYPE_OTHER, MEETING_TYPE_NEW_AGENT_TRAINING],
      name: 'Szkolenia'
  }},
  {path: 'szkolenie/kalendarz' , component: CalendarComponent, data: {modal: false }},
  {path: 'szkolenie/szczegoly/:id', component: MeetingDetailsComponent},



  {path: 'szkolenia-idd', component: AllIddTrainingsListComponent},
  {path: 'szkolenia-idd/dodaj', component: AddIddTrainingCertificateComponent},
  {path: 'szkolenia-idd/wczytaj', component: DecodeIddTrainingCertificatesComponent},
  {path: 'szkolenia-idd/szczegoly/:id', component: IddTrainingDetailsComponent},
  {path: 'szkolenia-idd/zaswiadczenia', component: AllIddTrainingCertificatesListComponent},
  {path: 'szkolenia-idd/zaswiadczenia360', component: AllIddTrainingCertificatesToCheckListComponent},


  // {path: 'chroniepl', component: AllRegistrationsListComponent,
  //   data: {chronieReport: 1, onlyChronie: 1, excludeColumns: ['ofwcaLastName', 'agreedToDeregister',
  //       'activeKrk', 'passedExam100p', 'passedExam40p', 'signedUpForAnExam', 'examPassed', 'sentToRegister',
  //       'deregistrationPack', 'insuranceCompanyType', 'statements', 'missingExam', 'company']}},
  // {path: 'chroniepl/nowe', component: AllRegistrationsListComponent,
  //   data: {chronieReport: 1, onlyChronie: 1, newChronieAccess: 1, excludeColumns: [ 'ofwcaLastName',
  //       'agreedToDeregister', 'activeKrk', 'passedExam100p', 'passedExam40p', 'signedUpForAnExam', 'examPassed',
  //       'sentToRegister', 'deregistrationPack', 'insuranceCompanyType', 'statements', 'missingExam', 'company']}},
  // {path: 'chroniepl/do-zablokowania', component: AllRegistrationsListComponent,
  //   data: {chronieReport: 1, onlyChronie: 1, revokedChronieAccess: 1, excludeColumns: ['ofwcaLastName',
  //       'agreedToDeregister', 'activeKrk', 'passedExam100p', 'passedExam40p', 'signedUpForAnExam', 'examPassed',
  //       'sentToRegister', 'deregistrationPack', 'insuranceCompanyType', 'statements', 'missingExam', 'company']}},
  {path: 'sprzedaz-importuj', component: SoldPolicyImportComponent},
  {path: 'sprzedaz-lista-importow', component: AllSoldPolicyImportListComponent},
  {path: 'sprzedaz-lista-polis', component: AllPoliciesListComponent},
  {path: 'sprzedaz-raporty', component: ReportsComponent},

  {path: 'tabele-prowizyjne', component: AllCommissionTablesListComponent},
  {path: 'tabele-prowizyjne/dodaj', component: AddCommissionTableComponent},
  {path: 'tabele-prowizyjne/szczegoly/:id', component: CommissionTableDetailsComponent},

  {path: 'ryzyka', component: AllRisksListComponent},
  {path: 'ryzyka/dodaj', component: AddRiskComponent},

  {path: 'raporty-tu', component: AllCommissionImportListComponent},
  {path: 'raporty-tu/importuj', component: CommissionImportComponent},
  {path: 'raporty-tu/prowizje', component: AllCommissionsListComponent},
  {path: 'raporty-tu/prowizje/szczegoly/:id', component: CommissionDetailsComponent},

  {path: 'przepiecia-polis', component: AllRedirectionsListComponent},
  {path: 'przepiecia-polis/dodaj', component: RedirectionAddComponent},
  {path: 'przepiecia-polis/szczegoly/:id', component: RedirectionDetailsComponent},
  {path: 'przepiecia-polis/importuj', component: RedirectionImportComponent},
  {path: 'przepiecia-polis/lista-importow', component: AllRedirectionImportsListComponent},

  {path: 'generowanie', component: JobsListComponent},

  {path: 'konfigurator', component: CommissionUpdatePackageListComponent},
  {path: 'konfigurator/dodaj', component: CommissionUpdatePackageAddComponent},
  {path: 'konfigurator/szczegoly/:id', component: CommissionUpdatePackageDetailsComponent},

  {path: 'raporty-tu/prowizje/archiwum', component: AllCommissionImportRowSettledListComponent},

  {path: 'rozliczenia', component: AllSettlementsListComponent},
  {path: 'rozliczenia/szczegoly/:id', component: SettlementDetailsComponent},
  // {path: 'rozliczenia/szablon-email', component: TemplateComponent},
  {path: 'rozliczenia/szablon-email', component: AllSettlementsTemplateListComponent},
  {path: 'rozliczenia/salda', component: AllContractBalanceListComponent},
  {path: 'rozliczenia/salda/szczegoly/:id', component: ContractBalanceDetailsComponent},

  {path: 'progi', component: AllThresholdsListComponent},
  {path: 'progi/dodaj', component: AddThresholdComponent},

  {path: 'aneksy', component: AllAnnexesListComponent},
  {path: 'aneksy/dodaj', component: AddAnnexComponent},

  {path: 'slownik-ryzyk', component: AllRiskDictsListComponent},
  {path: 'slownik-ryzyk/dodaj', component: AddRiskDictComponent},

  {path: 'masowa-edycja', component: MassEditionComponent},
  {path: 'masowa-edycja/aktualne', component: MassEditionComponent,  data: { billingMonth: 'current' }},
  {path: 'masowa-edycja/nowe', component: MassEditionComponent, data: { statusKey: 'new' }},
  {path: 'masowa-edycja/odrzucone', component: MassEditionComponent, data: { statusKey: 'reject' }},

  {path: 'faktury', component: AllInvoicesListComponent},
  {path: 'faktury/dodaj', component: AddInvoiceComponent},
  {path: 'faktury/szczegoly/:id', component: InvoiceDetailsComponent},
  {path: 'faktury/lista-do-przelewu-adamczuk', component: AllPaymentListComponent,
    data: { statusKey: [INVOICE_STATUS_TO_BE_REALIZED , INVOICE_STATUS_SUSPENDED ], companyKey: COMPANY_ASF}},
  {path: 'faktury/lista-do-przelewu-asf-premium', component: AllPaymentListComponent,
    data: { statusKey: [INVOICE_STATUS_TO_BE_REALIZED , INVOICE_STATUS_SUSPENDED],  companyKey: COMPANY_ASF_PREMIUM}},
  {path: 'faktury/lista-do-przelewu-multisfera', component: AllPaymentListComponent,
    data: { statusKey: [INVOICE_STATUS_TO_BE_REALIZED , INVOICE_STATUS_SUSPENDED],  companyKey: COMPANY_MULTISFERA}},
  {path: 'faktury/lista-plikow-do-banku', component: AllBankFilesListComponent },
  {path: 'faktury/historia-przelewow', component: PaymentHistoryComponent},

  {path: 'faktury/dodaj-rachunki', component: AddBillsComponent},

  {path: 'faktury/generator', component: InvoiceGeneratorComponent},

  {path: 'noty', component: InvoiceDocumentListComponent, data: {displayedColumns: [
        'number', 'party', 'company', 'issueDate',
        'netNot', 'invoiceNumber', 'remainingAmount', 'deductedAmount', 'action'
      ]}},
  {path: 'noty/dodaj', component: InvoiceDocumentCreateComponent},
  {path: 'noty/szczegoly/:id', component: InvoiceDocumentDetailsComponent},

  {path: 'newsletter', component: NewsletterCurrentComponent},
  {path: 'newsletter/historia', component: NewsletterListComponent},
  {path: 'newsletter/dodaj', component: NewsletterAddComponent},
  {path: 'newsletter/szczegoly/:id', component: NewsletterDetailsComponent},

  {path: 'support', component: AllSupportListComponent,  data: { serviceTypeKeys: SERVICE_TYPE_SUPPORT}},
  {path: 'support/dodaj', component: SupportAddComponent,  data: { serviceTypeKeys: SERVICE_TYPE_SUPPORT}},
  {path: 'support/szczegoly/:id', component: SupportDetailsComponent},

  {path: 'analizy', component: ReportOfwcasComponent},
  {path: 'analizy/ofwca', component: ReportOfwcasComponent},
  {path: 'analizy/partner', component: ReportPartnersComponent},
  {path: 'analizy/umowy', component: ReportContractsComponent},
  {path: 'analizy/rejestracje', component: ReportRegistrationsComponent},
  {path: 'analizy/identyfikatory', component: ReportIdentifiersComponent},
  {path: 'analizy/przepięcia-polis', component: ReportRedirectionComponent},
  {path: 'analizy/raporty', component: ReportListComponent},

  {path: 'marzowosc', component: CommissionMarginReportListComponent},

  {path: 'korporacja', component: AllCorporationListComponent,  data: { serviceTypeKeys: SERVICE_TYPE_CORPORATION}},
  {path: 'korporacja/dodaj', component: CorporationAddComponent,  data: { serviceTypeKeys: SERVICE_TYPE_CORPORATION}},
  {path: 'korporacja/szczegoly/:id', component: CorporationDetailsComponent},


  {path: 'asf360/aktualnosci', component: AllPostListComponent},
  {path: 'asf360/aktualnosci/szczegoly/:id', component: PostDetailsComponent},
  {path: 'asf360/aktualnosci/dodaj', component: PostAddComponent},

  {path: 'asf360/tagi', component: AllTagsListComponent},
  {path: 'asf360/tagi/dodaj', component: TagsAddComponent},
  {path: 'asf360/tagi/szczegoly/:id', component: TagsDetailsComponent},


  {path: 'asf360/tagi-uprawnienia', component: AllPermissionTagsListComponent},
  {path: 'asf360/tagi-uprawnienia/dodaj', component: PermissionTagsAddComponent},
  {path: 'asf360/tagi-uprawnienia/szczegoly/:id', component: PermissionTagsDetailsComponent},

  {path: 'blog-dobry-agent/artykuly', component: DaArticleListComponent},
  {path: 'blog-dobry-agent/artykuly/szczegoly/:id', component: DaArticleDetailsComponent},
  {path: 'blog-dobry-agent/artykuly/dodaj', component: DaArticleAddComponent},

  {path: 'blog-dobry-agent/autorzy', component: DaAuthorListComponent},
  {path: 'blog-dobry-agent/autorzy/szczegoly/:id', component: DaAuthorDetailsComponent},
  {path: 'blog-dobry-agent/autorzy/dodaj', component: DaAuthorAddComponent},

  {path: 'blog-dobry-agent/kategorie', component: DaCategoryListComponent},
  {path: 'blog-dobry-agent/kategorie/szczegoly/:id', component: DaCategoryDetailsComponent},
  {path: 'blog-dobry-agent/kategorie/dodaj', component: DaCategoryAddComponent},

  {path: 'blog-dobry-agent/tagi', component: DaTagListComponent},
  {path: 'blog-dobry-agent/tagi/szczegoly/:id', component: DaTagDetailsComponent},
  {path: 'blog-dobry-agent/tagi/dodaj', component: DaTagAddComponent},

  {path: 'baza-adresowa', component: AllAddressImportComponent},
  {path: 'baza-adresowa/lista', component: AllAddressImportRowComponent},
  {path: 'baza-adresowa/dodaj', component: AddressAddComponent},

  {path: 'dynamiczny-slownik', component: AllDynamicDictionaryListComponent},
  {path: 'dynamiczny-slownik/lista', component: AllDynamicDictionaryListComponent},
  {path: 'dynamiczny-slownik/dodaj', component: DynamicDictionaryAddComponent},
  {path: 'dynamiczny-slownik/szczegoly/:id', component: DynamicDictionaryDetailsComponent},
  {path: 'dynamiczny-slownik/import', component: DynamicDictionaryImportComponent},

  {path: 'formularze', component: DynamicFormListComponent},
  {path: 'formularze/lista', component: DynamicFormListComponent},
  {path: 'formularze/zgloszenia', component: DynamicFormApplyListComponent},
  {path: 'formularze/dodaj', component: AddDynamicFormComponent},
  {path: 'formularze/szczegoly/:id', component: DynamicFormsDetailsComponent, data: {
      statusKeys: [FORM_ROW_STATUS_TO_BE_SERVED, FORM_ROW_STATUS_SUCCESS, FORM_ROW_STATUS_LOSS, FORM_ROW_STATUS_NEW]}},

  {path: 'naleznosci/raporty', component: AllReceivablesImportsListComponent},
  {path: 'naleznosci/raporty/importuj', component: ReceivablesImportComponent},
  {path: 'naleznosci/lista', component: AllReceivablesImportsRowListComponent},
  {path: 'naleznosci/lista/do_weryfikacji', component: AllReceivablesImportsRowListComponent,
    data: { statusKey: [RECEIVABLES_IMPORT_ROW_STATUS_FOR_VERIFICATION]} },
  {path: 'naleznosci/lista/do_anulowania', component: AllReceivablesImportsRowListComponent,
    data: { statusKey: [RECEIVABLES_IMPORT_ROW_STATUS_TO_CANCELLED]} },
  {path: 'naleznosci/lista/nieoplacone', component: AllReceivablesImportsRowListComponent,
    data: { statusKey: [RECEIVABLES_IMPORT_ROW_STATUS_UNPAID]} },
  {path: 'naleznosci/lista/nowa', component: AllReceivablesImportsRowListComponent,
    data: { statusKey: [RECEIVABLES_IMPORT_ROW_STATUS_NEW]} },
  {path: 'naleznosci/lista/oplacone', component: AllReceivablesImportsRowListComponent,
    data: { statusKey: [RECEIVABLES_IMPORT_ROW_STATUS_PAID]} },
  {path: 'naleznosci/lista/anulowane', component: AllReceivablesImportsRowListComponent,
    data: { statusKey: [RECEIVABLES_IMPORT_ROW_STATUS_CANCELLED, RECEIVABLES_IMPORT_ROW_STATUS_REJECTED]} },
  {path: 'naleznosci/lista/szczegoly/:id', component: ReceivablesImportsRowDetailsComponent},
  {path: 'naleznosci/generowanie', component: ReceivablesJobListComponent},

  {path: 'naleznosci/lista/wplaty_zgloszone', component: AllReceivablesImportsRowListComponent,
    data: { statusKey:  [RECEIVABLES_IMPORT_ROW_STATUS_PAYMENT_REPORTED]} },

  // {path: 'naleznosci/zestawienia/dodaj', component: StatementAddComponent},
  // {path: 'naleznosci/zestawienia/lista/zgloszone_do_rozliczenia', component: AllReceivablesStatementListComponent,
  //   data: { statusKey: [RECEIVABLES_STATEMENT_STATUS_REPORTED_FOR_SETTLEMENT]} },
  // {path: 'naleznosci/zestawienia/lista/oplacone', component: AllReceivablesStatementListComponent,
  //   data: { statusKey: [RECEIVABLES_STATEMENT_STATUS_PAID]} },
  // {path: 'naleznosci/zestawienia/lista/oplacone_czesciowo', component: AllReceivablesStatementListComponent,
  //   data: { statusKey: [RECEIVABLES_STATEMENT_STATUS_PARTIALLY_PAID]} },
  // {path: 'naleznosci/zestawienia/lista/anulowane', component: AllReceivablesStatementListComponent,
  //   data: { statusKey: [RECEIVABLES_STATEMENT_STATUS_CANCELLED]} },
  // {path: 'naleznosci/zestawienia/szczegoly/:id', component: ReceivablesStatementDetailsComponent},

  {path: 'naleznosci/salda/lista', component: AllReceivablesBalanceListComponent},
  {path: 'naleznosci/salda/szczegoly/:id', component: ReceivablesBalanceDetailsComponent},


  {path: 'naleznosci/wplaty', component: AllReceivablesPaymentImportListComponent},
  {path: 'naleznosci/wplaty/import', component: ReceivablesPaymentImportComponent},
  {path: 'naleznosci/wplaty/lista_importow', component: AllReceivablesPaymentImportListComponent},
  {path: 'naleznosci/wplaty/rozliczone', component: AllReceivablesPaymentImportRowListComponent,
    data: {statusKey: [RECEIVABLES_PAYMENT_STATUS_SETTLED] , ownerName: 'Podmiot transakcji'}},
  {path: 'naleznosci/wplaty/nierozliczone', component: AllReceivablesPaymentImportRowListComponent,
    data: {statusKey: [RECEIVABLES_PAYMENT_STATUS_UNSETTLED] , ownerName: 'Podmiot transakcji'}},
  {path: 'naleznosci/wplaty/anulowane', component: AllReceivablesPaymentImportRowListComponent,
    data: {statusKey: [RECEIVABLES_PAYMENT_STATUS_CANCELED] , ownerName: 'Podmiot transakcji'}},
  {path: 'naleznosci/wplaty/przelewy-wychodzace', component: AllReceivablesPaymentImportRowListComponent,
    data: {statusKey: [RECEIVABLES_PAYMENT_STATUS_OUTGOING_PAYMENT], ownerName: 'Podmiot transakcji'}},
  {path: 'naleznosci/wplaty/szczegoly/:id', component: ReceivablesPaymentImportRowDetailsComponent},
  {path: 'naleznosci/wplaty/dodaj', component: ReceivablesPaymentImportRowAddComponent},
  {path: 'naleznosci/wplaty/przeksiegowania', component: ReceivablesPaymentImportTransferAddComponent},

  {path: 'wysylka-maili/dodaj', component: EmailSendAddComponent},
  {path: 'wysylka-maili', component: EmailSendJobListComponent},
  {path: 'wysylka-maili/szczegoly/:id', component: EmailSendDetailsComponent},

  {path: 'ock/raporty/uzytkownicy', component: OckUserListComponent},
  {path: 'ock/raporty/polisy', component: OckPolicyListComponent},
  {path: 'ock/raporty/firma', component: OckCompanyListComponent},
  {path: 'ock/import/lista', component: AllOckImportListComponent},
  {path: 'ock/import/nip', component: AllNipListComponent},
  {path: 'ock/import/vin', component: AllVinListComponent},
  {path: 'ock/import/nip/dodaj', component: NipAddComponent},
  {path: 'ock/import/vin/dodaj', component: VinAddComponent},




  {path: 'automatyczne-odrzucanie', component: AllOfwcasListComponent, data: {
      rejectedCommission: 1,
      displayedColumns: ['fullName', 'status', 'rau', 'assetsRegional', 'actionsRejectedCommission']
    }},

  {path: 'terminale/polisy/szczegoly/:id', component: TerminalsDetailsComponent},
  {path: 'terminale/polisy/lista', component: AllTerminalsListComponent},
  {path: 'terminale/polisy/zaplacone', component: AllTerminalsListComponent, data: {statusKey: [TERMINAL_STATUS_PAID]}},
  {path: 'terminale/polisy/nierozliczone', component: AllTerminalsListComponent, data: {statusKey: [TERMINAL_STATUS_TO_BE_REALIZED, TERMINAL_STATUS_SUSPENDED]}},
  {path: 'terminale/raporty/importuj', component: TerminalsImportComponent},
  {path: 'terminale/raporty', component: AllTerminalsImportsListComponent},

  {path: 'terminale/transakcje/szczegoly/:id', component: TerminalsImportsRowDetailsComponent},
  {path: 'terminale/transakcje/rozliczone', component: AllTerminalsImportsRowListComponent, data: {statusKey: [TERMINALS_IMPORT_ROW_STATUS_SETTLED]}},
  {path: 'terminale/transakcje/nierozliczone', component: AllTerminalsImportsRowListComponent, data: {statusKey: [TERMINALS_IMPORT_ROW_STATUS_UNSETTLED]}},
  {path: 'terminale/transakcje/do-weryfikacji', component: AllTerminalsImportsRowListComponent, data: {statusKey: [TERMINALS_IMPORT_ROW_STATUS_FOR_VERIFICATION]}},

  {path: 'terminale/przelewy/przelewy/lista', component: TerminalsBankJobListComponent},
  {path: 'terminale/przelewy/polisy/lista', component: AllTerminalsListComponent, data: {statusKey: [TERMINAL_STATUS_TO_BE_REALIZED, TERMINAL_STATUS_SUSPENDED], generate: 1, assignedTransaction: 1 }},
  {path: 'partnerzy/linki-afiliacyjne/szczegoly/:id', component: AffiliateCodeDetailsComponent},


  {path: 'serwis-plikow', component: FileManagerListComponent},
  {path: 'serwis-plikow/tag', component: AllTagListComponent},
  {path: 'udostepnianie', component: AllSharedFileListComponent},
  {path: 'serwis-plikow/strona/dodaj', component: AddPageComponent},
  {path: 'serwis-plikow/strona/:id', component: PageDetailsComponent},
  {path: 'serwis-plikow/strona', component: PageListComponent},
  {path: 'serwis-plikow/:id', component: FileManagerListComponent},

  {path: 'zmiana-danych-osobowych/lista', component: AllPersonalDataChangeListComponent},
  {path: 'zmiana-danych-osobowych/w-toku', component: AllPersonalDataChangeListComponent, data: {
      statusKey: [PERSONAL_DATA_CHANGE_STATUS_SENT_TO_IC],
    }},
  {path: 'zmiana-danych-osobowych/zrealizowane', component: AllPersonalDataChangeListComponent, data: {
      statusKey: [PERSONAL_DATA_CHANGE_STATUS_COMPLETED],
    }},
  {path: 'zmiana-danych-osobowych/szczegoly/:id', component: PersonalDataChangeDetailsComponent},
  {path: 'zmiana-danych-osobowych/zgloszone', component: AllPersonalDataChangeListComponent, data: {
      statusKey: [PERSONAL_DATA_CHANGE_STATUS_REPORTED],
    }},
  {path: 'chronie', component: ChroniePaymentListComponent},
  {path: 'chronie/job', component: ChronieJobListComponent},
  {path: 'chronie/komunikaty-techniczne', component: ChronieAllMaintenanceWindowListComponent},
  {path: 'chronie/komunikaty-techniczne/dodaj', component: ChronieMaintenanceWindowAddComponent},
  {path: 'chronie/komunikaty-techniczne/szczegoly/:id', component: ChronieMaintenanceWindowDetailsComponent},
  {path: 'chronie/direct', component: HiperioConfigDirectListComponent},
  {path: 'chronie/direct/szczegoly/:id', component: HiperioConfigDirectDetailsComponent},

  {path: 'dobry-agent', component: DobryAgentNotificationSettingsComponent},


  {path: 'naleznosci/przelewy/dodaj', component: TransferAddComponent},
  {path: 'naleznosci/przelewy', component: TransferListComponent},
  {path: 'naleznosci/przelewy/pliki/lista', component: TransferBankJobListComponent},
  {path: 'naleznosci/przelewy/szczegoly/:id', component: TransferDetailsComponent},
  {path: 'naleznosci/przelewy/do-zrealizowania', component: TransferListComponent,
    data: {statusKey: [RECEIVABLES_TRANSFER_STATUS_TO_BE_COMPLETED], generate: 1}},

  {path: 'kadry', component: AllEmployeeListComponent},
  {path: 'kadry/szczegoly/:id', component: EmployeeDetailsComponent},
  {path: 'kadry/wnioski-urlopowe/szczegoly/:id', component: LeaveApplicationDetailsComponent},
  {path: 'kadry/wnioski-urlopowe/odrzucony', component: AllLeaveApplicationListComponent,
    data: {statusKeys: [LEAVE_APPLICATION_STATUS_REJECTED]}},
  {path: 'kadry/wnioski-urlopowe/do-akceptacji', component: AllLeaveApplicationListComponent,
    data: {statusKeys: [LEAVE_APPLICATION_STATUS_FOR_ACCEPTANCE]}},
  {path: 'kadry/wnioski-urlopowe/anulowany', component: AllLeaveApplicationListComponent,
    data: {statusKeys: [LEAVE_APPLICATION_STATUS_CANCEL]}},
  {path: 'kadry/wnioski-urlopowe/zaakceptowany', component: AllLeaveApplicationListComponent,
    data: {statusKeys: [LEAVE_APPLICATION_STATUS_ACCEPTED]}},
  {path: 'kadry/wnioski-urlopowe', component: AllLeaveApplicationListComponent},

  {path: 'urzadzenia', component: AllDeviceListComponent},
  {path: 'urzadzenia/szczegoly/:id', component: DeviceDetailsComponent},
  {path: 'urzadzenia/licencje', component: AllLicenseListComponent},
  {path: 'urzadzenia/licencje/szczegoly/:id', component: LicenseDetailsComponent},
  {path: 'urzadzenia/uzytkownicy', component: AllUserListComponent,
    data: {limitedView: 1, onlyLicenses: 1, active: 1, employee: true, displayedColumns: ['licenseFullName', 'phone', 'email']}},
  {path: 'urzadzenia/uzytkownicy/szczegoly/:id', component: UserLicensesDetailsComponent},

  {path: 'stan-magazynowy', component: AllWarehouseProductListComponent},
  {path: 'stan-magazynowy/szczegoly/:id', component: WarehouseProductDetailsComponent},

  {path: 'wyniki-konkursow/import', component: CompetitionDataImportComponent},
  {path: 'wyniki-konkursow/pola-dodatkowe', component: AdditionalFieldsListComponent},
  {path: 'wyniki-konkursow/lista-importow', component: CompetitionImportListComponent},
  {path: 'wyniki-konkursow/pola-dodatkowe/szczegoly/:id', component: AdditionalFieldsDetailsComponent},
  {path: 'wyniki-konkursow/szczegoly/:id', component: CompetitionImportRowListComponent},
  {path: 'wyniki-konkursow/wyniki/szczegoly/:id', component: CompetitionImportRowDetailsComponent},
  {path: 'wyniki-konkursow/wyniki', component: CompetitionImportValuesListComponent},
  {path: 'wydania-z-magazynu/lista', component: CompetitionWzListComponent},
  {path: 'wydania-z-magazynu/szczegoly/:id', component: CompetitionWzRowsListComponent},
  {path: 'wydania-z-magazynu/dokumenty', component: AllDocumentListComponent, data: {
      typeKeys: [FILE_TYPE_AWARD_RECEPTION_PROTOCOL],
      masterModule: 'Marketing',
      excludeColumns: ['insuranceCompany' , 'insuranceCompany' , 'updatedAt' , 'partnerOrOfwca' , 'contractType']}},

  {path: 'import-tagow', component: AllPartnerTagsImportComponent},

  {path: 'usuniete', component: LogDeletedDataListComponent},

  {path: 'ofwca/hiperio/szczegoly/:id', component: HiperioRegistrationConfigDetailsComponent},

  {path: 'hiperio/loginy', component: CredentialsJobsListComponent},
  {path: 'hiperio/konta', component: UserJobsListComponent},
  {path: 'hiperio/loginy-testowe', component: HiperioTestAccessFormListComponent},
  {path: 'hiperio/loginy-zmiany', component: HiperioConcludeChangeRegistrationComponent},
  {path: 'hiperio/dostepy-testowe',
    component: AllRegistrationsListComponent,
    data: {disableFilters: true, disableBreadcrumb: true, hiperioTestAccess: true, customBreadcrumb: true,
      displayColumns: ['insuranceCompany', 'ofwca', 'name', 'status']}},
  {path: 'import-danych-kontaktowych', component: AllImportContactsComponent},
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
